import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {GlobalService} from '../global.service';
import {TipoTrigger, TipoEvento, TipoPeriodicidade, TipoEstado} from '../../model/constantes';
import {UtilApi} from './util.api';

@Injectable()
export class ConstantesApiService {

    constructor(public http: HttpClient, public globalService: GlobalService) {

    }

    public buscaTipoTrigger(codigo: number): Observable<Array<TipoTrigger>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/constante/tipoTrigger/' + codigo;

        return this.http.get<Array<TipoTrigger>>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}})
            .map(response => response['tipoTrigger']);
    }

    public buscaTipoEvento(codigo: number): Observable<Array<TipoEvento>> {
        if (codigo == null) {
            return;
        }
        let url = this.globalService.getConfiguracao().api_catalogo + '/constante/tipoEvento/' + codigo;

        return this.http.get<Array<TipoEvento>>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}})
            .map(response => response['tipoEvento']);
    }

    public buscaTipoPeriodicidade(codigo: number): Observable<Array<TipoPeriodicidade>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/constante/tipoPeriodicidade/' + codigo;

        return this.http.get<Array<TipoPeriodicidade>>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}})
            .map(response => response['tipoPeriodicidade']);
    }

    public buscaTipoEstado(codigo: number): Observable<Array<TipoEstado>> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/constante/tipoEstado/' + codigo;

        return this.http.get<Array<TipoEstado>>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}})
            .map(response => response['tipoEstado']);
    }

    public buscaTipoModelo(): Observable<any> {
        let url = this.globalService.getConfiguracao().api_sia + '/download/codTemplates.json';

        return this.http.get(url, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }
}



// WEBPACK FOOTER //
// ./src/service/api/constantes.api.ts